import React from 'react';
import styled, { css } from 'styled-components';
import { BlockLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity, useLang } from '@shapeable/ui';
import { useSite } from '../../hooks/use-site';
import { ValueBubble } from '../elements/value-bubble';
import { MetricLayout } from '../entities/metric-layout';

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    justify-content: center;
  `,
});

const ValueStyles = breakpoints({
  base: css`
    margin-top: ${theme.UNIT(2)};
    align-self: center;
  `,
});


// -------- Components -------->

const My = {
  Container: styled(MetricLayout)<ContainerProps>`${ContainerStyles}`,
    Value: styled(ValueBubble)`${ValueStyles}`,
};

export const BlockLayoutTotalCarbonCaptured: BlockLayoutComponent = (props) => {
  const { className, children } = props;
  const entity = useEntity(props.entity);
  const t = useLang();
  const { metrics } = useSite();
  const { totalCarbonCapturedPerYear } = metrics;

  return (
    <My.Container showContent entity={entity} className={className}>
      <My.Value value={totalCarbonCapturedPerYear} name={t('Carbon Captured')} unit={t('(tons CO2e)')} /> 
    </My.Container>
  )
};